import Button from 'react-bootstrap/Button'

function HomeButton() {
  const handleClick = () => { document.location = "/" }
  return <Button variant="light" onClick={handleClick}>Home</Button>
}

export default HomeButton
